import { render, staticRenderFns } from "./NotifiedPeoplePropertyYN.vue?vue&type=template&id=353c7b9c"
import script from "./NotifiedPeoplePropertyYN.vue?vue&type=script&lang=js"
export * from "./NotifiedPeoplePropertyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports